import Button from "@mui/material/Button";

import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";

const Actions = withLiteObserverAndTheme(() => {
  return (
    <Button
      variant="contained"
      disabled={
        !getKhattabat101MGeneralStore().canOpenOneOOneMConversations.get()
      }
      onClick={async () =>
        await getKhattabatMatchingStore().openOneOOneMConversations()
      }
      sx={{ alignSelf: "flex-end" }}
    >
      {i18n.get("SEND")}
    </Button>
  );
});

export default Actions;
